module.exports = __webpack_public_path__ + "/build/web/images/register-training@3x.54f83ec058340556dad027e748cfc2c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/register-training@3x.jpg
// module id = 193
// module chunks = 13